<template>
	<div id="site-header" class="absolute top-0 flex-shrink-0 w-full bg-white">
		<div class="container px-4 py-4 lg:py-8">
			<div class="flex flex-wrap items-center">
				<div class="w-full mb-4 lg:w-1/2 lg:mb-0">
					<img class="h-8 mx-auto logo lg:mx-0 lg:h-auto" src="@/assets/logo.jpg">
				</div>
				<div class="w-full lg:w-1/2">
					<div class="leading-none lg:float-right font-montserrat">
						<div class="hidden text-base font-bold uppercase lg:block text-siteRed">Call Us At</div>
						<div class="text-xl sm:text-2xl lg:text-5xl">
							<!-- <div class="flex items-center justify-center font-bold lg:justify-end">
								<a href="https://wa.me/60192220771" class="hover:underline">
									<IconWhatsapp class="inline-block h-4 pr-1 lg:h-6"/>
									019-2220771
								</a>
							</div> -->
							<div class="flex items-center justify-center font-semibold lg:justify-end">
								<a href="tel:+6564631188" class="-mb-1 duration-150 border-b-2 border-transparent lg:border-b-4 hover:border-current">
									<IconPhone class="inline-block h-4 pr-1 lg:hidden lg:h-6"/>
									<span>
										6463 1188
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
// import IconWhatsapp from '@/components/svg/IconWhatsapp.vue'
import IconPhone from '@/components/svg/IconPhone.vue'
export default {
	components: {
		// IconWhatsapp,
		IconPhone,
	}
}
</script>

<style scoped lang="scss">
#site-header {
	// @apply sticky top-0;
	background-color: white;
}
.logo {
	min-height: 3rem;
	max-height: 4rem;
}
</style>
